var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.728 17.2942L15.8332 13.3994C15.6574 13.2236 15.4191 13.126 15.1691 13.126H14.5323C15.6105 11.747 16.2512 10.0125 16.2512 8.12559C16.2512 3.63698 12.6142 0 8.12559 0C3.63698 0 0 3.63698 0 8.12559C0 12.6142 3.63698 16.2512 8.12559 16.2512C10.0125 16.2512 11.747 15.6105 13.126 14.5323V15.1691C13.126 15.4191 13.2236 15.6574 13.3994 15.8332L17.2942 19.728C17.6614 20.0952 18.2552 20.0952 18.6185 19.728L19.7241 18.6225C20.0913 18.2552 20.0913 17.6614 19.728 17.2942ZM8.12559 13.126C5.36367 13.126 3.12523 10.8914 3.12523 8.12559C3.12523 5.36367 5.35977 3.12523 8.12559 3.12523C10.8875 3.12523 13.126 5.35977 13.126 8.12559C13.126 10.8875 10.8914 13.126 8.12559 13.126Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchmin);
export default __webpack_public_path__ + "static/media/searchmin.2ace36e1a63ccb21e768d97828cffca4.svg";
export { ForwardRef as ReactComponent };